import { TextField } from "@mui/material";
import { Box } from "@mui/system";
import TableFilterAcionts from "../TableFilterAcionts";

interface IProps {
  filter: IFilter;
  setFilter: (filter: IFilter) => void;
  handleSearch: () => void;
  handleCancel: () => void;
}

interface IFilter {
  status: boolean;
  data: {
    full_name: string;
    wallet_address: string;
  };
}
const initFilterData: IFilter = {
  status: true,
  data: {
    full_name: "",
    wallet_address: "",
  },
};

export default function FilterForm({
  filter,
  setFilter,
  handleSearch,
  handleCancel
}: IProps) {
  const handleChanges = (event: React.ChangeEvent<HTMLInputElement>) => {
    setFilter({
      ...filter,
      data: {
        ...filter.data,
        [event.target.name]: event.target.value,
      },
    });
  };

  return (
    <Box>
      <Box sx={{ display: "flex", flexWrap: "wrap", gap: 1, mt: 2 }}>
        <TextField
          label="Full Name"
          variant="standard"
          value={filter.data.full_name}
          name="full_name"
          onChange={handleChanges}
          sx={{ flex: "1 1 40%" }}
        />
        <TextField
          label="Wallet Address"
          variant="standard"
          value={filter.data.wallet_address}
          name="wallet_address"
          onChange={handleChanges}
          sx={{ flex: "1 1 40%" }}
        />
      </Box>
      <TableFilterAcionts
        disableCancel={false}
        handleClearSearch={() => {
          setFilter(initFilterData);

          handleCancel();
        }}
        handleSearch={handleSearch}
      />
    </Box>
  );
}
